var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manage-info" }, [
    _vm.showDelete
      ? _c(
          "button",
          {
            staticClass: "manage-info__delete",
            attrs: { disabled: _vm.disableDelete, type: "button" },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$emit("delete")
              }
            }
          },
          [_c("deleteIcon")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "manage-info__content" }, [
      _c(
        "div",
        { staticClass: "manage-info__status-wrap" },
        [_c("addedIcon")],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "manage-info__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "manage-info__price" }, [
        _vm._v(_vm._s(_vm.priceDisplay))
      ])
    ]),
    _vm._v(" "),
    _vm.description
      ? _c("p", {
          staticClass: "manage-info__description",
          domProps: { innerHTML: _vm._s(_vm.description) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.showAction
      ? _c(
          "button",
          {
            staticClass: "manage-info__action",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("action")
              }
            }
          },
          [
            _c("span", { staticClass: "manage-info__action-label" }, [
              _vm._v(_vm._s(_vm.actionLabel))
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "manage-info__action-chevron",
                attrs: { "aria-hidden": "true" }
              },
              [_c("angleDownCircled", { attrs: { color: "#2168BC" } })],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62e8fef4", { render: render, staticRenderFns: staticRenderFns })
  }
}